import React from 'react'
import { useTranslation } from 'next-i18next'
import {
  Badge as DSBadge,
  IconBuilding,
  IconRocket
} from '@machobear/design-system'

export type BadgeType = 'sponsored' | 'specialOffer' | 'unitsAvailable'

export interface BadgeProps {
  type: BadgeType
  count?: number
}

export const Badge: React.FC<BadgeProps> = ({ type, count }) => {
  const { t } = useTranslation()
  switch (type) {
    case 'sponsored':
      return (
        <DSBadge tone="info" icon={<IconRocket />} variant="solid">
          {t('Sponsored', 'Sponsored')}
        </DSBadge>
      )

    case 'specialOffer':
      return <DSBadge tone="promote">{t('Special Offer')}</DSBadge>

    case 'unitsAvailable':
      return (
        <DSBadge tone="neutral" icon={<IconBuilding />} variant="solid">
          {count ?? 0} {t('b.badge.units_available', 'Units Available')}
        </DSBadge>
      )

    default:
      return null
  }
}
